
export const quickTakeData = {
  distance: "75 miles (120 km)",
  travelTime: "2.5–3 hours each way",
  bestFor: "Nature lovers, photographers, cultural explorers, anyone with a full day",
  skipIf: "You only have 2 days in Antigua or prefer adrenaline activities over scenic beauty",
  idealDuration: "Full day (10–12 hours) or overnight recommended"
};

export const travelOptionsData = [
  {
    option: "Organized Tour",
    cost: "$40–$60",
    comfort: "High",
    travelTime: "3–3.5 hours",
    pros: "Guide included, boat rides arranged, village visits planned",
    cons: "Fixed schedule, limited free time, group pace"
  },
  {
    option: "Shuttle Service",
    cost: "$25–$35",
    comfort: "Medium",
    travelTime: "2.5–3 hours",
    pros: "Affordable, direct to Panajachel, flexible once there",
    cons: "No guide, need to arrange boats yourself"
  },
  {
    option: "Private Driver",
    cost: "$90–$140",
    comfort: "Very High",
    travelTime: "2.5 hours",
    pros: "Flexible schedule, door-to-door, can stop at viewpoints",
    cons: "Most expensive option, need to negotiate"
  },
  {
    option: "Chicken Bus",
    cost: "$3–$6",
    comfort: "Low",
    travelTime: "4+ hours",
    pros: "Authentic local experience, very cheap",
    cons: "Multiple transfers, crowded, no AC, slow"
  }
];

export const costBreakdownData = [
  { item: "Organized Tour (full day)", cost: "$40–$60" },
  { item: "Shuttle (round-trip)", cost: "$25–$35" },
  { item: "Private Driver", cost: "$90–$140" },
  { item: "Boat rides (Panajachel to villages)", cost: "$3–$5 per ride" },
  { item: "Lunch at lakeside restaurant", cost: "$8–$15" },
  { item: "Village entrance fees", cost: "Free–$2" },
  { item: "Typical Total (Tour)", cost: "$60–$90" }
];

export const villagesData = [
  {
    name: "Panajachel (Pana)",
    nickname: "The Tourist Hub",
    description: "The main gateway town on the north shore. Calle Santander is lined with shops, restaurants, and tour agencies. Most shuttles and tours arrive here first. It\\'s the most developed and touristy village but convenient for boat connections.",
    bestFor: "Shopping, restaurants, boat connections to other villages",
    timeNeeded: "1–2 hours",
    highlight: "Calle Santander shopping street and lakefront promenade"
  },
  {
    name: "San Juan La Laguna",
    nickname: "The Art Village",
    description: "A quiet, artistic village known for natural dye textiles, art cooperatives, and murals. Women\\'s weaving cooperatives offer demonstrations of traditional backstrap loom techniques. The village feels authentic and less touristy than Panajachel.",
    bestFor: "Art lovers, textile enthusiasts, photographers",
    timeNeeded: "2–3 hours",
    highlight: "Women\\'s textile cooperatives and natural dye workshops"
  },
  {
    name: "San Pedro La Laguna",
    nickname: "The Backpacker Hub",
    description: "A lively village popular with backpackers and digital nomads. Known for affordable Spanish schools, yoga retreats, and a vibrant nightlife scene. The Indian Nose hike departs from nearby and offers stunning sunrise views.",
    bestFor: "Budget travelers, Spanish students, nightlife seekers",
    timeNeeded: "2–3 hours",
    highlight: "Cafes, rooftop bars, and Indian Nose sunrise hike"
  },
  {
    name: "Santiago Atitl\\u00e1n",
    nickname: "The Cultural Heart",
    description: "The largest lakeside village and home to the Tz\\'utujil Maya people. Visit the shrine of Maximon (a syncretic Maya-Catholic deity), the central market, and the beautiful church. The village offers deep cultural immersion.",
    bestFor: "Culture enthusiasts, history buffs, spiritual travelers",
    timeNeeded: "2–3 hours",
    highlight: "Maximon shrine and traditional Tz\\'utujil culture"
  },
  {
    name: "San Marcos La Laguna",
    nickname: "The Wellness Village",
    description: "A tranquil village known for yoga retreats, meditation centers, and holistic healing. The energy here is calm and spiritual. Beautiful swimming spots along the lakeshore and lush tropical gardens throughout the village.",
    bestFor: "Yoga practitioners, wellness seekers, those wanting peace",
    timeNeeded: "2–3 hours",
    highlight: "Yoga retreats, meditation centers, and swimming in the lake"
  }
];

export const timelineData = [
  { time: "5:30–6:00 AM", activity: "Pickup from Antigua hotel", duration: "—" },
  { time: "6:00–8:30 AM", activity: "Drive to Panajachel via highland roads", duration: "2.5–3 hours" },
  { time: "8:30–9:00 AM", activity: "Arrive in Panajachel, board boat", duration: "30 min" },
  { time: "9:00–10:30 AM", activity: "Boat to San Juan La Laguna, explore art cooperatives", duration: "1.5 hours" },
  { time: "10:30–12:00 PM", activity: "Visit Santiago Atitl\\u00e1n or San Pedro La Laguna", duration: "1.5 hours" },
  { time: "12:00–1:00 PM", activity: "Lakeside lunch with volcano views", duration: "1 hour" },
  { time: "1:00–2:00 PM", activity: "Free time, shopping, or swimming", duration: "1 hour" },
  { time: "2:00–2:30 PM", activity: "Boat back to Panajachel", duration: "30 min" },
  { time: "2:30–5:00 PM", activity: "Return drive to Antigua", duration: "2.5–3 hours" },
  { time: "5:00–6:00 PM", activity: "Arrive back in Antigua", duration: "—" }
];

export const proTips = [
  {
    title: "Leave early—really early",
    description: "Depart Antigua by 6 AM. The lake is calmest and clearest in the morning. Afternoon winds (called Xocomil) can make boat rides rough and views hazy."
  },
  {
    title: "Pick 2–3 villages max",
    description: "Don\\'t try to visit every village in one day. Choose 2–3 based on your interests. Quality over quantity makes for a much better experience."
  },
  {
    title: "Bring layers",
    description: "The lake sits at 5,100 feet elevation. Mornings are cool, midday is warm, and boat rides are windy. A light jacket is essential."
  },
  {
    title: "Carry cash in small bills",
    description: "Most lakeside villages are cash-only. ATMs exist in Panajachel but are unreliable. Bring enough quetzales for the day."
  },
  {
    title: "Negotiate boat prices",
    description: "Public lanchas (boats) have fixed prices ($3–$5). Private boats are negotiable. Always confirm the price before boarding."
  },
  {
    title: "Consider staying overnight",
    description: "A day trip is possible but rushed. If you can spare 2 days, stay overnight in San Pedro, San Marcos, or Panajachel for a much richer experience."
  }
];

export const commonMistakes = [
  "Trying to visit too many villages in one day (stick to 2–3)",
  "Not leaving Antigua early enough—afternoon winds ruin the lake experience",
  "Forgetting cash (most villages are cash-only, ATMs are unreliable)",
  "Wearing flip-flops on boats (wet, slippery docks are common)",
  "Skipping sunscreen—the lake reflects UV intensely at altitude",
  "Booking the cheapest tour without checking if boat rides are included",
  "Not bringing a waterproof bag for electronics on the boat"
];

export const faqData = [
  {
    question: "Is Lake Atitl\\u00e1n worth visiting from Antigua as a day trip?",
    answer: "Yes, but it\\'s a long day (10–12 hours total). The lake is one of Guatemala\\'s most stunning natural wonders, surrounded by three volcanoes and traditional Maya villages. If you have a full day, it\\'s absolutely worth it. However, staying overnight gives you a much better experience—you\\'ll have more time to explore villages and enjoy the lake without rushing."
  },
  {
    question: "How long does it take to get from Antigua to Lake Atitl\\u00e1n?",
    answer: "The drive takes 2.5–3 hours each way via the Pan-American Highway. Tours and shuttles may take slightly longer (3–3.5 hours) due to hotel pickups. The road is paved but winding through the highlands. You\\'ll arrive in Panajachel, the main gateway town on the lake\\'s north shore."
  },
  {
    question: "What is the best way to get from Antigua to Lake Atitl\\u00e1n?",
    answer: "For day trips, organized tours ($40–$60) are the easiest option—they handle transport, boats, and village visits. Shuttles ($25–$35) are cheaper but you\\'ll need to arrange boats yourself in Panajachel. Private drivers ($90–$140) offer the most flexibility. Chicken buses are cheap ($3–$6) but slow and require transfers."
  },
  {
    question: "Which villages should I visit at Lake Atitl\\u00e1n?",
    answer: "For a day trip, visit 2–3 villages: San Juan La Laguna (art and textiles), Santiago Atitl\\u00e1n (culture and Maximon shrine), and Panajachel (shopping and restaurants). If you prefer wellness, swap one for San Marcos La Laguna. San Pedro La Laguna is great for backpackers and cafes."
  },
  {
    question: "Is Lake Atitl\\u00e1n safe for tourists?",
    answer: "Yes, the main tourist villages (Panajachel, San Pedro, San Juan, San Marcos) are safe during the day. Use common sense: don\\'t flash valuables, avoid walking alone at night in isolated areas, and use registered boats. The boat rides are safe in calm morning conditions. Afternoon winds can make crossings rougher but not dangerous."
  },
  {
    question: "Can I swim in Lake Atitl\\u00e1n?",
    answer: "Yes, swimming is possible in several spots, especially near San Marcos La Laguna and some hotels in Panajachel. The water is clean in most areas but can be cold (around 68\\u00b0F/20\\u00b0C). Some areas have algae blooms seasonally. Locals swim regularly, and it\\'s generally considered safe."
  },
  {
    question: "What should I bring for a Lake Atitl\\u00e1n day trip?",
    answer: "Essentials: sunscreen, sunglasses, light jacket (for boat rides and morning chill), cash in small bills, waterproof bag for electronics, comfortable walking shoes, swimsuit (optional), and a camera. The sun is intense at 5,100 feet elevation, so sun protection is critical."
  },
  {
    question: "Can I combine Lake Atitl\\u00e1n with Chichicastenango?",
    answer: "Yes, but it works best as an overnight trip. Chichicastenango is roughly between Antigua and the lake. Visit the market in the morning (Thursday or Sunday only), then continue to Lake Atitl\\u00e1n in the afternoon. Stay overnight at the lake and return to Antigua the next day. Doing both in one day is exhausting."
  },
  {
    question: "How much does a Lake Atitl\\u00e1n day trip cost?",
    answer: "Budget $60–$90 for a comfortable day trip: tour or shuttle ($25–$60), boat rides ($6–$15), lunch ($8–$15), and incidentals ($5–$10). Private drivers cost more ($90–$140) but can split costs among a group. Shopping and activities in villages are extra."
  },
  {
    question: "What is the best time of year to visit Lake Atitl\\u00e1n?",
    answer: "November through April (dry season) offers the best conditions: clear skies, calm mornings, and stunning volcano views. The lake is beautiful year-round, but May through October brings afternoon rain and cloudier skies. Mornings are usually clear even in rainy season, so early departures are key."
  },
  {
    question: "Do I need a guide for Lake Atitl\\u00e1n?",
    answer: "Not required, but helpful for a day trip. Guides arrange boats, navigate villages, and provide cultural context. If you take a shuttle, you can explore independently—Panajachel is easy to navigate, and boat captains know the routes. For deeper cultural experiences in Santiago Atitl\\u00e1n or San Juan, a local guide adds significant value."
  },
  {
    question: "How do boats work at Lake Atitl\\u00e1n?",
    answer: "Public lanchas (small motorboats) run between villages from Panajachel. They depart when full (usually every 20–30 minutes) and cost $3–$5 per person per ride. Private boats can be hired for $20–$50 depending on distance. The main dock in Panajachel connects to all major villages. Rides take 15–45 minutes depending on the destination."
  }
];

export const schemaData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Article",
      "headline": "Antigua to Lake Atitl\\u00e1n: Complete Day Trip Guide (2025)",
      "description": "Everything you need to know about visiting Lake Atitl\\u00e1n from Antigua Guatemala: shuttle options, costs, best villages to visit, and whether a day trip is worth it.",
      "image": "https://public.readdy.ai/ai/img_res/f220b15ed9fcc526fab792192928fb84.jpg",
      "author": {
        "@type": "Organization",
        "name": "La Antigua Guatemala Travel Guide"
      },
      "publisher": {
        "@type": "Organization",
        "name": "La Antigua Guatemala Travel Guide",
        "logo": {
          "@type": "ImageObject",
          "url": "https://la-antigua-guatemala.com/logo.png"
        }
      },
      "datePublished": "2025-01-20",
      "dateModified": "2025-01-20",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://la-antigua-guatemala.com/antigua-to-lake-atitlan-shuttle"
      },
      "inLanguage": "en-US"
    },
    {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://la-antigua-guatemala.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Day Trips",
          "item": "https://la-antigua-guatemala.com/day-trips-from-antigua-guatemala"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Antigua to Lake Atitl\\u00e1n",
          "item": "https://la-antigua-guatemala.com/antigua-to-lake-atitlan-shuttle"
        }
      ]
    },
    {
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Is Lake Atitl\\u00e1n worth visiting from Antigua as a day trip?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, but it\\u2019s a long day (10\\u201312 hours total). The lake is one of Guatemala\\u2019s most stunning natural wonders, surrounded by three volcanoes and traditional Maya villages. If you have a full day, it\\u2019s absolutely worth it."
          }
        },
        {
          "@type": "Question",
          "name": "How long does it take to get from Antigua to Lake Atitl\\u00e1n?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The drive takes 2.5\\u20133 hours each way via the Pan-American Highway. Tours and shuttles may take slightly longer due to hotel pickups."
          }
        },
        {
          "@type": "Question",
          "name": "What is the best way to get from Antigua to Lake Atitl\\u00e1n?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "For day trips, organized tours ($40\\u2013$60) are the easiest option. Shuttles ($25\\u2013$35) are cheaper but you arrange boats yourself. Private drivers ($90\\u2013$140) offer the most flexibility."
          }
        },
        {
          "@type": "Question",
          "name": "Which villages should I visit at Lake Atitl\\u00e1n?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "For a day trip, visit 2\\u20133 villages: San Juan La Laguna (art and textiles), Santiago Atitl\\u00e1n (culture and Maximon shrine), and Panajachel (shopping and restaurants)."
          }
        },
        {
          "@type": "Question",
          "name": "Is Lake Atitl\\u00e1n safe for tourists?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, the main tourist villages are safe during the day. Use common sense: don\\u2019t flash valuables, avoid walking alone at night, and use registered boats."
          }
        },
        {
          "@type": "Question",
          "name": "Can I swim in Lake Atitl\\u00e1n?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, swimming is possible in several spots, especially near San Marcos La Laguna. The water is clean in most areas but can be cold (around 68\\u00b0F/20\\u00b0C)."
          }
        },
        {
          "@type": "Question",
          "name": "How much does a Lake Atitl\\u00e1n day trip cost?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Budget $60\\u2013$90 for a comfortable day trip: tour or shuttle ($25\\u2013$60), boat rides ($6\\u2013$15), lunch ($8\\u2013$15), and incidentals ($5\\u2013$10)."
          }
        },
        {
          "@type": "Question",
          "name": "Can I combine Lake Atitl\\u00e1n with Chichicastenango?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, but it works best as an overnight trip. Visit the market in the morning, then continue to Lake Atitl\\u00e1n. Stay overnight and return to Antigua the next day."
          }
        }
      ]
    }
  ]
};
